// Static data for İDK BOKT website

export const products = [
  {
    id: 1,
    slug: "istehlak-kreditleri",
    title: "İstehlak Krediti",
    description: "Şəxsi ehtiyaclarınız üçün sərfəli kredit həlli",
    mainAdvantage: "Minimum sənəd tələbi və sürətli baxılma prosesi",
    features: [
      "Minimum sənəd tələbi",
      "Sürətli baxılma prosesi",
      "Çevik ödəniş şərtləri",
      "Zəmanətsiz kredit imkanı"
    ],
    icon: "Wallet",
    details: {
      heroTitle: "Şəxsi ehtiyaclarınızı operativ qarşılayın",
      heroDescription: "İstehlak krediti, fiziki şəxslərin gündəlik və şəxsi xərclərini qarşılamaq üçün rahat və sürətli maliyyə həllidir.",
      terms: [
        { label: "Kreditin məbləği", value: "10 000 AZN-dək", icon: "Wallet" },
        { label: "Kreditin müddəti", value: "36 ayadək", icon: "Calendar" },
        { label: "Aylıq faiz dərəcəsi", value: "2.7%-dən başlayaraq", icon: "TrendingUp" }
      ],
      sections: [
        {
          title: "Borcalana dair",
          type: "requirements",
          items: [
            "Azərbaycan Respublikasının vətəndaşı",
            "Yaş həddi 18 - 65 arası olan şəxslər (Kredit müddətinin bitmə zamanına maksimum 65 yaş)",
            "Borcalanın cari gecikməsi və restrukturizasiyası olmamalıdır. Son iki ildə müsbət kredit tarixçəsi olmalıdır. Zamin qismində çıxış edən şəxsin də cari gecikməsi olmamalıdır"
          ]
        },
        {
          title: "Təminat",
          type: "collateral",
          items: [
            "Daşınar və daşınmaz əmlak",
            "Kredit tarixçəsi müsbət olan zamin"
          ]
        }
      ]
    }
  },
  {
    id: 2,
    slug: "qizil-kreditleri",
    title: "Qızıl Krediti",
    description: "Qızıl və qiymətli əşyalar əsasında təminatlı kredit",
    mainAdvantage: "Eyni gündə təsdiq və nağd ödəniş imkanı",
    features: [
      "Eyni gündə təsdiq",
      "Qızıl və qiymətli əşyalar girovu",
      "Aşağı faiz dərəcəsi",
      "Sadə sənədləşmə"
    ],
    icon: "Gem",
    details: {
      heroTitle: "Qızılınızı dəyərləndirin, nağdlaşdırın",
      heroDescription: "Qızıl Krediti, qızıl zinət əşyalarınızı təminat kimi istifadə edərək sürətli və əlverişli kredit imkanı təqdim edir.",
      terms: [
        { label: "Kreditin məbləği", value: "20 000 AZN-dək", icon: "Wallet" },
        { label: "Kreditin müddəti", value: "36 ayadək", icon: "Calendar" },
        { label: "Aylıq faiz dərəcəsi", value: "2.2%-dən başlayaraq", icon: "TrendingUp" }
      ],
      sections: [
        {
          title: "Borcalana dair",
          type: "requirements",
          items: [
            "Azərbaycan Respublikasının vətəndaşı",
            "Yaş həddi 18 - 65 arası olan şəxslər (Kredit müddətinin bitmə zamanına maksimum 65 yaş)"
          ]
        },
        {
          title: "Təminat",
          type: "collateral",
          items: [
            "Qızıl zinət əşyası"
          ]
        }
      ]
    }
  },
  {
    id: 3,
    slug: "avto-lizinq",
    title: "Avto Lizinq",
    description: "Avtomobil əldə etmək üçün lizinq həlli",
    mainAdvantage: "Aşağı ilkin ödəniş və uzunmüddətli müddət",
    features: [
      "Yeni və işlənmiş avtomobillər",
      "İlkin ödəniş 20%-dən",
      "4 ilədək lizinq müddəti",
      "Sürətli təsdiq prosesi"
    ],
    icon: "Car",
    details: {
      heroTitle: "Xəyallarınızın avtomobilini idarə edin!",
      heroDescription: "Bizim lizinq məhsulu, yeni və istifadə edilmiş avtomobillər almaq istəyən fiziki şəxslər üçün nəzərdə tutulmuşdur.",
      terms: [
        { label: "Kreditin məbləği", value: "30 000 AZN-dək", icon: "Wallet" },
        { label: "Lizinqin müddəti", value: "48 ayadək", icon: "Calendar" },
        { label: "Aylıq faiz dərəcəsi", value: "2.3%-dən başlayaraq", icon: "TrendingUp" }
      ],
      sections: [
        {
          title: "Borcalana dair",
          type: "requirements",
          items: [
            "Azərbaycan Respublikasının, Bakı və ya Sumqayıt şəhərlərində yaşayan və qeydiyyatda olan şəxslər",
            "Yaş həddi 22 - 65 arası olan şəxslər",
            "Lizinq qərarı borcalanın ödəniş qabiliyyəti təhlil edilmədən, yalnız ilkin ödəniş və kredit tarixçəsi əsasında verilir",
            "Müraciətçinin VÖEN-i olmalıdır"
          ]
        },
        {
          title: "Avtomobilə dair",
          type: "requirements",
          items: [
            "İkinci əl avtomobilləri - istehsal tarixi 15 ilədək olan avtomobillər.",
            "Mühərrikin həcmi - 2.5 lt-dək",
            "Yürüş məsafəsi - 250 000 km-dək"
          ]
        }
      ]
    }
  }
];

export const whyChooseUs = [
  {
    title: "Operativ müraciət",
    description: "Müraciətlərə tez yanaşma və vaxtınıza qənaət",
    icon: "Zap"
  },
  {
    title: "Şəffaf şərtlər",
    description: "Bütün şərtlər, faizlər və komissiyalar açıq təqdim olunur",
    icon: "Eye"
  },
  {
    title: "Rahat əlaqə",
    description: "Telefon, online və ya ofisə gələrək asan əlaqə",
    icon: "PhoneCall"
  },
  {
    title: "Müştəri yönümlü xidmət",
    description: "Hər müştəriyə fərdi yanaşma və professional məsləhət",
    icon: "Users"
  },
  {
    title: "Sadə müraciət prosesi",
    description: "Növbəsiz və asan sənədləşdirmə",
    icon: "FileCheck"
  }
];

export const applicationSteps = [
  {
    number: "01",
    title: "Müraciət formasını doldurun",
    description: "Online forma vasitəsilə tələb olunan məlumatları daxil edin"
  },
  {
    number: "02",
    title: "Əməkdaşımız sizinlə əlaqə saxlayır",
    description: "Mütəxəssisimiz qısa müddətdə sizinlə əlaqə saxlayır və sualları aydınlaşdırır"
  },
  {
    number: "03",
    title: "Şərtlər dəqiqləşdirilir",
    description: "Sizin üçün ən uyğun kredit şərtləri və ödəniş planı müzakirə olunur"
  },
  {
    number: "04",
    title: "Kredit müraciətinizə baxılır",
    description: "Müraciətiniz qiymətləndirilir və yekun qərar bildirilir"
  }
];

// Company info (real data from idkcredit.com - placeholders for production replacement)
export const companyInfo = {
  name: "İnkişafa Dəstək Kreditləri BOKT",
  fullName: "\"İnkişafa Dəstək Kreditləri\" Bank Olmayan Kredit Təşkilatı",
  foundedYear: "2011",
  phones: ["+994 12 464 85 88"],
  email: "info@idkcredit.com",
  address: "Nərimanov ray, Əhməd Rəcəbli küç 29",
  workingHours: "Bazar ertəsi - Cümə: 09:00 - 18:00"
};

export const faqItems = [
  {
    question: "Kredit almaq üçün hansı sənədlər tələb olunur?",
    answer: "Əsas sənəd şəxsiyyət vəsiqəsidir. Seçdiyiniz məhsuldan asılı olaraq əlavə sənədlər (gəlir barədə məlumat, qızıl-zinət əşyası, avtomobil sənədləri və s.) tələb oluna bilər. Dəqiq siyahı müraciətiniz zamanı əməkdaşımız tərəfindən bildirilir."
  },
  {
    question: "Müraciətimə nə qədər müddətə baxılır?",
    answer: "Onlayn müraciətinizi aldıqdan sonra əməkdaşımız adətən 1 iş günü ərzində sizinlə əlaqə saxlayır. Kredit müraciətinin yekun qiymətləndirilməsi isə sənədlər təqdim olunduqdan sonra qısa müddətdə tamamlanır."
  },
  {
    question: "Hansı məbləğdə kredit ala bilərəm?",
    answer: "Məbləğ seçdiyiniz məhsuldan asılıdır."
  },
  {
    question: "Aylıq ödənişimi əvvəlcədən necə hesablaya bilərəm?",
    answer: "Saytımızdakı Kredit Kalkulyatoru vasitəsilə məbləğ, müddət və faiz dərəcəsini seçərək təxmini aylıq ödənişinizi dərhal görə bilərsiniz. Yekun şərtlər müraciətiniz zamanı fərdi olaraq dəqiqləşdirilir."
  },
  {
    question: "Krediti vaxtından əvvəl ödəmək mümkündürmü?",
    answer: "Bəli, krediti vaxtından əvvəl tam və ya qismən ödəmək mümkündür. Vaxtından əvvəl ödənişin şərtləri kredit müqaviləsində əks olunur və müqavilə bağlanmazdan əvvəl sizə ətraflı izah edilir."
  },
  {
    question: "Kredit tarixçəm ideal deyilsə, müraciət edə bilərəmmi?",
    answer: "Bəli, müraciət edə bilərsiniz. Hər bir müraciətə fərdi yanaşırıq və qərar yalnız kredit tarixçəsinə deyil, ümumi maliyyə vəziyyətinizə əsasən verilir."
  },
  {
    question: "Onlayn müraciət etdikdən sonra proses necə davam edir?",
    answer: "Formanı göndərdikdən sonra əməkdaşımız sizinlə əlaqə saxlayaraq suallarınızı cavablandırır və lazımi sənədləri bildirir. Kreditin rəsmiləşdirilməsi ofisimizdə aparılır."
  }
];
